<template>
  <div>
    <v-data-table :headers="headers" :items="elements" class="elevation-1">
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Elements</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="mb-2" v-bind="attrs" v-on="on">Add Element</v-btn>
            </template>
            <v-card>
              <validation-observer v-slot="{ handleSubmit }">
                <form @submit.prevent="handleSubmit(saveElement)">
                  <v-card-title class="headline grey lighten-2" primary-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="6">
                          <validation-provider
                            :vid="uuid()"
                            name="Name"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <v-text-field label="Name" v-model="editedElement.name"></v-text-field>
                            <span class="validation-message">{{ errors[0] }}</span>
                          </validation-provider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="6">
                          <validation-provider
                            :vid="uuid()"
                            name="Type"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <v-select label="Type" :items="typeGroups" v-model="typeGroup"></v-select>
                            <span class="validation-message">{{ errors[0] }}</span>
                          </validation-provider>
                        </v-col>

                        <v-col cols="6" v-if="typeGroup === 'Base Types'">
                          <validation-provider
                            :vid="uuid()"
                            name="Type"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <v-select
                              label="Type"
                              :items="baseTypes"
                              v-model="editedElement.type.name"
                            ></v-select>
                            <span class="validation-message">{{ errors[0] }}</span>
                          </validation-provider>
                        </v-col>

                        <v-col cols="6" v-if="typeGroup === 'User Data Types'">
                          <validation-provider
                            :vid="uuid()"
                            name="Type"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <v-select
                              label="Type"
                              :items="userDataTypes"
                              v-model="editedElement.type.derivedName"
                            ></v-select>
                            <span class="validation-message">{{ errors[0] }}</span>
                          </validation-provider>
                        </v-col>
                      </v-row>

                      <v-row v-if="typeGroup === 'Array'">
                        <v-col cols="6">
                          <validation-provider :vid="uuid()" name="Base Type" v-slot="{ errors }">
                            <v-select
                              label="Base Type"
                              :items="baseTypes"
                              v-model="editedElement.type.baseType"
                            ></v-select>
                            <span class="validation-message">{{ errors[0] }}</span>
                          </validation-provider>
                        </v-col>

                        <v-col cols="12">
                          <v-data-table
                            :headers="dimensionHeaders"
                            :items="editedElement.type.dimensions"
                            class="elevation-1"
                          >
                            <template v-slot:top>
                              <v-toolbar flat color="white">
                                <v-toolbar-title>Dimensions</v-toolbar-title>

                                <v-spacer></v-spacer>

                                <v-dialog v-model="dimensionDialog" max-width="500px">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      class="mb-2"
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="addDimension"
                                    >Add Dimension</v-btn>
                                  </template>

                                  <v-card>
                                    <validation-observer>
                                      <v-card-title class="headline grey lighten-2" primary-title>
                                        <span class="headline">
                                          {{
                                          dimensionFormTitle
                                          }}
                                        </span>
                                      </v-card-title>

                                      <v-card-text>
                                        <v-container>
                                          <v-row>
                                            <v-col cols="6">
                                              <validation-provider
                                                :vid="uuid()"
                                                name="Lower"
                                                rules="required"
                                                v-slot="{ errors }"
                                              >
                                                <v-text-field
                                                  label="Lower"
                                                  v-model="editedDimension.lower"
                                                ></v-text-field>

                                                <span class="validation-message">{{ errors[0] }}</span>
                                              </validation-provider>
                                            </v-col>

                                            <v-col cols="6">
                                              <validation-provider
                                                :vid="uuid()"
                                                name="Upper"
                                                rules="required"
                                                v-slot="{ errors }"
                                              >
                                                <v-text-field
                                                  label="Upper"
                                                  v-model="editedDimension.upper"
                                                ></v-text-field>

                                                <span class="validation-message">{{ errors[0] }}</span>
                                              </validation-provider>
                                            </v-col>
                                          </v-row>
                                        </v-container>
                                      </v-card-text>

                                      <v-card-actions>
                                        <v-spacer></v-spacer>

                                        <v-btn
                                          color="blue darken-1"
                                          text
                                          @click="resetDimensionDialog()"
                                        >Cancel</v-btn>

                                        <v-btn
                                          color="blue darken-1"
                                          text
                                          @click="saveDimension"
                                        >Save</v-btn>
                                      </v-card-actions>
                                    </validation-observer>
                                  </v-card>
                                </v-dialog>
                              </v-toolbar>
                            </template>

                            <template v-slot:item.actions="{ item }">
                              <v-icon small class="mr-2" @click="editDimension(item)">mdi-pencil</v-icon>
                              <v-icon small @click="deleteDimension(item)">mdi-delete</v-icon>
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="6">
                          <validation-provider
                            :vid="uuid()"
                            name="Initial Value"
                            v-slot="{ errors }"
                          >
                            <v-text-field
                              label="Initial Value"
                              v-model="editedElement.initialValue"
                            ></v-text-field>
                            <span class="validation-message">{{ errors[0] }}</span>
                          </validation-provider>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="resetDialog()">Cancel</v-btn>
                    <v-btn color="blue darken-1" text type="submit">Save</v-btn>
                  </v-card-actions>
                </form>
              </validation-observer>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editElement(item)">mdi-pencil</v-icon>
        <v-icon small @click="deleteElement(item)">mdi-delete</v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { find, findIndex, map, isUndefined, cloneDeep } from "lodash";
import uuid from "src/mixins/uuid";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  name: "DataTypeStructure",
  props: ["tempId"],
  components: { ValidationProvider, ValidationObserver },
  mixins: [uuid],
  data() {
    return {
      dialog: false,
      headers: [
        {
          text: "Name",
          sortable: false,
          value: "name",
        },
        {
          text: "Type",
          sortable: false,
          value: "type.name",
        },
        {
          text: "Initial Value",
          sortable: false,
          value: "initialValue",
        },
        { text: "Actions", value: "actions", sortable: false },
      ],
      editedElement: {
        type: {},
      },
      typeGroups: ["Base Types", "User Data Types", "Array"],
      typeGroup: null,
      baseTypes: [
        "BOOL",
        "SINT",
        "INT",
        "DINT",
        "LINT",
        "USINT",
        "UINT",
        "UDINT",
        "ULINT",
        "REAL",
        "LREAL",
        "TIME",
        "DATE",
        "TOD",
        "DT",
        "STRING",
        "BYTE",
        "WORD",
        "DWORD",
        "LWORD",
      ],
      dimensionHeaders: [
        {
          text: "Lower",
          sortable: false,
          value: "lower",
        },
        {
          text: "Upper",
          sortable: false,
          value: "upper",
        },
        { text: "", value: "actions", sortable: false },
      ],
      dimensionDialog: false,
      editedDimension: {},
    };
  },
  computed: {
    dataType() {
      return find(this.$store.state.dataTypes, { tempId: this.tempId });
    },
    elements() {
      return map(this.dataType.baseType.elements, (element) => ({
        tempId: this.uuid(),
        ...element,
      }));
    },
    formTitle() {
      return this.editedElement.tempId ? "Update Element" : "Add Element";
    },
    userDataTypes() {
      return map(this.$store.state.dataTypes, "name");
    },
    dimensionFormTitle() {
      if (this.editedElement.type.name === "array") {
        return this.editedDimension.tempId ? "Edit Dimension" : "New Dimension";
      }

      return "";
    },
  },
  methods: {
    resetDialog() {
      this.dialog = false;
      this.editedElement = {
        type: {},
      };
    },
    editElement(element) {
      this.editedElement = element;
      this.dialog = true;
      this.typeGroup = this.getTypeGroup(element);
    },
    saveElement() {
      if (this.typeGroup === "Array") {
        this.editedElement.type.name = "array";
        // this.editedElement.type = `ARRAY [${this.editedElement.dimension}] OF ${this.editedElement.baseType}`;
      } else if (this.typeGroup === "User Data Types") {
        this.editedElement.type.name = "derived";
      }

      const { tempId } = this.editedElement;

      if (tempId) {
        const index = findIndex(this.elements, { tempId });
        this.elements.splice(index, 1, this.editedElement);
        this.$store.dispatch("updateDataType", {
          ...this.dataType,
          baseType: {
            ...this.dataType.baseType,
            elements: this.elements,
          },
        });
      } else {
        if (isUndefined(this.dataType.baseType.elements)) {
          this.dataType.baseType.elements = [];
        }

        this.dataType.baseType.elements.push(this.editedElement);
        this.$store.dispatch("updateDataType", this.dataType);
      }

      this.resetDialog();
    },
    async deleteElement({ tempId }) {
      if (
        await this.$confirm("Are you sure you want to delete this element?")
      ) {
        const index = findIndex(this.elements, { tempId });
        this.elements.splice(index, 1);
        this.$store.dispatch("updateDataType", {
          ...this.dataType,
          baseType: {
            ...this.dataType.baseType,
            elements: this.elements,
          },
        });
      }
    },
    save() {
      this.$store.dispatch("updateDataType", this.dataType);
    },
    getTypeGroup(element) {
      if (element.type.name === "derived") {
        return "User Data Types";
      }

      if (element.type.name === "array") {
        return "Array";
      }

      return "Base Types";
    },
    addDimension() {
      this.editedDimension = {};
    },
    editDimension(value) {
      this.editedDimension = value;
      this.dimensionDialog = true;
    },
    saveDimension() {
      if (this.editedDimension.tempId) {
        let dimensions = cloneDeep(this.editedElement.type.dimensions);

        const index = findIndex(dimensions, {
          tempId: this.editedDimension.tempId,
        });

        dimensions.splice(index, 1, this.editedDimension);

        this.editedElement = {
          ...this.editedElement,
          type: {
            ...this.editedElement.type,
            dimensions,
          },
        };
      } else {
        let dimensions = cloneDeep(this.editedElement.type.dimensions);

        if (isUndefined(dimensions)) {
          dimensions = [];
        }

        dimensions.push({
          ...this.editedDimension,
          tempId: this.uuid(),
        });

        this.editedElement = {
          ...this.editedElement,
          type: {
            ...this.editedElement.type,
            dimensions,
          },
        };
      }

      this.resetDimensionDialog();
    },
    async deleteDimension({ tempId }) {
      if (
        await this.$confirm("Are you sure you want to delete this dimension?")
      ) {
        let dimensions = cloneDeep(this.editedElement.type.dimensions);

        const index = findIndex(dimensions, {
          tempId,
        });

        dimensions.splice(index, 1);

        this.editedElement = {
          ...this.editedElement,
          type: {
            ...this.editedElement.type,
            dimensions,
          },
        };
      }
    },
    resetDimensionDialog() {
      this.dimensionDialog = false;
    },
  },
};
</script>
